module.exports = __webpack_public_path__ + "static/img/1003_small.cb2f3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1003_small.png
// module id = yh7F
// module chunks = 1